Object.defineProperty(exports,"__esModule",{value:true});var _isFunction2=require("lodash/isFunction");var _isFunction3=_interopRequireDefault(_isFunction2);var _throttle2=require("lodash/throttle");var _throttle3=_interopRequireDefault(_throttle2);var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[typeof Symbol==="function"?Symbol.iterator:"@@iterator"](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if((typeof Symbol==="function"?Symbol.iterator:"@@iterator")in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _victoryCore=require("victory-core");function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}


var Helpers={








scale:function scale(currentDomain,originalDomain,factor){var _originalDomain=_slicedToArray(
originalDomain,2),fromBound=_originalDomain[0],toBound=_originalDomain[1];var _currentDomain=_slicedToArray(
currentDomain,2),from=_currentDomain[0],to=_currentDomain[1];
var range=Math.abs(from-to);
var midpoint=+from+range/2;
var newRange=range*Math.abs(factor)/2;
var minDomain=_victoryCore.Collection.containsDates(originalDomain)?
[new Date(midpoint-4),new Date(midpoint)]:
[midpoint-1/Number.MAX_SAFE_INTEGER,midpoint];
var newDomain=[
_victoryCore.Collection.getMaxValue([midpoint-newRange,fromBound]),
_victoryCore.Collection.getMinValue([midpoint+newRange,toBound])];

return Math.abs(minDomain[1]-minDomain[0])>Math.abs(newDomain[1]-newDomain[0])?
minDomain:newDomain;
},








pan:function pan(currentDomain,originalDomain,delta){var _currentDomain$map=
currentDomain.map(function(val){return+val;}),_currentDomain$map2=_slicedToArray(_currentDomain$map,2),fromCurrent=_currentDomain$map2[0],toCurrent=_currentDomain$map2[1];var _originalDomain$map=
originalDomain.map(function(val){return+val;}),_originalDomain$map2=_slicedToArray(_originalDomain$map,2),fromOriginal=_originalDomain$map2[0],toOriginal=_originalDomain$map2[1];
var lowerBound=fromCurrent+delta;
var upperBound=toCurrent+delta;
var newDomain=void 0;
if(lowerBound>fromOriginal&&upperBound<toOriginal){
newDomain=[lowerBound,upperBound];
}else if(lowerBound<fromOriginal){
var dx=toCurrent-fromCurrent;
newDomain=[fromOriginal,fromOriginal+dx];
}else if(upperBound>toOriginal){
var _dx=toCurrent-fromCurrent;
newDomain=[toOriginal-_dx,toOriginal];
}else{
newDomain=currentDomain;
}
return _victoryCore.Collection.containsDates(currentDomain)||_victoryCore.Collection.containsDates(originalDomain)?
newDomain.map(function(val){return new Date(val);}):newDomain;
},

getDomainScale:function getDomainScale(domain,scale){var _domain$x=_slicedToArray(
domain.x,2),from=_domain$x[0],to=_domain$x[1];
var rangeX=scale.x.range();
var plottableWidth=Math.abs(rangeX[0]-rangeX[1]);
return plottableWidth/(to-from);
},

handleAnimation:function handleAnimation(ctx){
var getTimer=(0,_isFunction3.default)(ctx.getTimer)&&ctx.getTimer.bind(ctx);
if(getTimer&&(0,_isFunction3.default)(getTimer().bypassAnimation)){
getTimer().bypassAnimation();
return(0,_isFunction3.default)(getTimer().resumeAnimation)?
function(){return getTimer().resumeAnimation();}:undefined;
}
},

onMouseDown:function onMouseDown(evt,targetProps){
evt.preventDefault();
var originalDomain=targetProps.originalDomain||targetProps.domain;
var currentDomain=targetProps.currentDomain||targetProps.zoomDomain||originalDomain;var _Selection$getSVGEven=
_victoryCore.Selection.getSVGEventCoordinates(evt),x=_Selection$getSVGEven.x;
return[{
target:"parent",
mutation:function mutation(){
return{
startX:x,domain:currentDomain,cachedZoomDomain:targetProps.zoomDomain,
originalDomain:originalDomain,currentDomain:currentDomain,panning:true,
parentControlledProps:["domain"]};

}}];

},

onMouseUp:function onMouseUp(){
return[{
target:"parent",
mutation:function mutation(){
return{panning:false};
}}];

},

onMouseLeave:function onMouseLeave(){
return[{
target:"parent",
mutation:function mutation(){
return{panning:false};
}}];

},

onMouseMove:function onMouseMove(evt,targetProps,eventKey,ctx){var _this=this;
if(targetProps.panning){var _ret=function(){var
scale=targetProps.scale,startX=targetProps.startX,onDomainChange=targetProps.onDomainChange,domain=targetProps.domain,zoomDomain=targetProps.zoomDomain;var _Selection$getSVGEven2=
_victoryCore.Selection.getSVGEventCoordinates(evt),x=_Selection$getSVGEven2.x;
var originalDomain=targetProps.originalDomain||domain;
var lastDomain=targetProps.currentDomain||targetProps.zoomDomain||originalDomain;
var calculatedDx=(startX-x)/_this.getDomainScale(lastDomain,scale);
var nextXDomain=_this.pan(lastDomain.x,originalDomain.x,calculatedDx);
var currentDomain={x:nextXDomain,y:originalDomain.y};
var resumeAnimation=_this.handleAnimation(ctx);
if((0,_isFunction3.default)(onDomainChange)){
onDomainChange(currentDomain);
}
return{v:[{
target:"parent",
callback:resumeAnimation,
mutation:function mutation(){
return{
parentControlledProps:["domain"],
domain:currentDomain,currentDomain:currentDomain,originalDomain:originalDomain,cachedZoomDomain:zoomDomain};

}}]};}();if(typeof _ret==="object")return _ret.v;

}
},

onWheel:function onWheel(evt,targetProps,eventKey,ctx){
if(!targetProps.allowZoom){
return{};
}var
onDomainChange=targetProps.onDomainChange,domain=targetProps.domain,zoomDomain=targetProps.zoomDomain;
var originalDomain=targetProps.originalDomain||domain;
var lastDomain=targetProps.currentDomain||zoomDomain||originalDomain;var
x=lastDomain.x;
var xBounds=originalDomain.x;
var sign=evt.deltaY>0?1:-1;
var delta=Math.min(Math.abs(evt.deltaY/300),0.75);
var nextXDomain=this.scale(x,xBounds,1+sign*delta);
var currentDomain={x:nextXDomain,y:originalDomain.y};
var resumeAnimation=this.handleAnimation(ctx);
if((0,_isFunction3.default)(onDomainChange)){
onDomainChange(currentDomain);
}
return[{
target:"parent",
callback:resumeAnimation,
mutation:function mutation(){
return{
domain:currentDomain,currentDomain:currentDomain,originalDomain:originalDomain,cachedZoomDomain:zoomDomain,
parentControlledProps:["domain"],panning:false};

}}];

}};exports.default=



{
onMouseDown:Helpers.onMouseDown.bind(Helpers),
onMouseUp:Helpers.onMouseUp.bind(Helpers),
onMouseLeave:Helpers.onMouseLeave.bind(Helpers),
onMouseMove:(0,_throttle3.default)(Helpers.onMouseMove.bind(Helpers),16,{leading:true}),
onWheel:(0,_throttle3.default)(Helpers.onWheel.bind(Helpers),16,{leading:true})};


//////////////////
// WEBPACK FOOTER
// ./~/victory-chart/lib/components/containers/zoom-helpers.js
// module id = 522
// module chunks = 0